module.exports = __webpack_public_path__ + "img/ua.76996335.svg";